import React, { Component } from "react";
import { connect } from "react-redux";
import constants from "../../globalization";
import API from "../../requests";
import { getPopupConfig } from "../../components/Popup";
import View from "./views";
import UTILLib from "../../util";
import FireboardUtils from "../../util/fireboard-util";

class FireboardPreAuth extends Component {
  iso2 = this.props.reduxProps?.currencyInfo?.iso2;

  constructor(props) {
    super(props);
    this.state = {
      popup: undefined,
      phoneNumber: '',
      item: {},
    }
  }

  componentDidMount() {
    const {
      history,
      reduxProps: { storeInfo, deviceInfo },
    } = this.props;

    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 15 }
      });
      return;
    }

    try {
      const { location } = history || {};
      const { item, selectedTicket = {} } = location?.state || {};
      const parsedItem = JSON.parse(item);
      const { tickets, unpaidAmount } = parsedItem || {};
      this.setState({ item: parsedItem });
      if (selectedTicket && selectedTicket.memberId) {
        this.getMemberDetails(selectedTicket.memberId);
      } else {
        if (Array.isArray(tickets) && tickets.length > 0) {
          tickets.forEach(ticket => {
            const { ticketStatusId, preAuth, memberId } = ticket || {};
            if (ticketStatusId === 0 && preAuth && unpaidAmount > 0) {
              this.getMemberDetails(memberId);
            }
          });
        }
      }
    } catch (error) {
      console.warn('error parsing', error);
    }

  }

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  getSpinner = (type: string, heading: any, message: any) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          this.closePopup();
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  invokeGratuityApi = (gratuity) => {
    const { reduxProps, history } = this.props;
    const { storeInfo, deviceApi, login } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { suggestedTipIncludesTax } = storeInfo?.data?.tipInfo || {};
    const { latitude, longitude } = UTILLib.location;
    const { item } = this.state;
    const unpaid = item.unpaidAmount;

    const { location } = history || {};
    const { selectedTicket = {} } = location?.state || {};
    let preauthTicket = {};
    if (!FireboardUtils.isObjectBlank(selectedTicket)) {
      preauthTicket = selectedTicket;
    } else {
      preauthTicket =
        item.tickets &&
        item.tickets.find(ticket => ticket.ticketStatusId === 0 && ticket.preAuth && unpaid > 0);
    }

    let gratuityCalculated = 0;
    if (suggestedTipIncludesTax) {
      gratuityCalculated = +(((unpaid * +gratuity) / 100).toFixed(2));
    } else {
      const { unpaidAmount, taxAmount, subTotalAmount } = item?.selectedCheckDetails || {};
      const taxPercent = taxAmount / subTotalAmount;
      const subTotalForUnpaidAmt = unpaidAmount / (1 + taxPercent);
      gratuityCalculated = +(((subTotalForUnpaidAmt * +gratuity) / 100).toFixed(2));
    }

    this.getSpinner('spinner', 'Posting payment', null);

    API.preAuthCompleteFB({
      latitude,
      longitude,
      geoLocation: `${latitude} ${longitude}`,
      storeId: storeInfo?.data?.id,
      deviceId: deviceId,
      employeeId: login && login.data && login.data.id,
      checkHeaderId: item.id,
      ticketId: preauthTicket ? preauthTicket.id : null,
      totalAmount: +unpaid,
      tipAmount: gratuityCalculated,
      paymentAmount: +((+unpaid + gratuityCalculated).toFixed(2)),
    })
      .then(res => {
        console.info('response from preAuthCompleteFB', res);
        const popup = getPopupConfig("success", () => {
          this.closePopup();
          this.onClose();
        });
        popup.heading = constants.paymentDoneSuccesssfully;
        popup.message = constants.paymentProcessed;
        this.setState({ popup });
        FireboardUtils.addNetworkLogs(res);
      })
      .catch(error => {
        console.info('error', error.request, error.response);
        const errorMsg = error.response ? error.response.data.message : error.message;
        this.getSpinner('error', null, errorMsg);
        FireboardUtils.addNetworkLogs(error.response);
      });
  };

  getMemberDetails = memberId => {
    API.getMemberDetails({ memberId })
      .then(res => {
        console.debug('response from getMemberDetails', res);
        this.setState({
          phoneNumber: FireboardUtils.formattedPhoneNumber(res.data.phoneNumber, this.iso2),
        });
        // this.phoneNumber = FireboardUtils.formattedPhoneNumber(res.data.phoneNumber, this.iso2);
        FireboardUtils.addNetworkLogs(res);
      })
      .catch(error => {
        FireboardUtils.addNetworkLogs(error.response);
        console.info('error calling member details', error.request);
      });
  };

  confirmPopup = (gratuity) => {
    const popup = getPopupConfig('error');
    popup.heading = constants.CustomTipConfirm;
    popup.message = constants.gratuityPostMessage;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.closePopup(),
      },
      {
        text: constants.yes,
        onClick: () => {
          this.invokeGratuityApi(gratuity);
        },
      },
    ];
    this.setState({ popup });
  };

  tipSubmit = (gratuity) => {
    this.confirmPopup(gratuity);
  };

  onClose = () => {
    const { history } = this.props;
    const { location } = history || {};
    const { state } = location || {};
    const { deviceTypeId } = state || {};
    if (deviceTypeId === 13) {
      history && history.push({
        pathname: '/printRequests',
        state: { managerMode: true }
      });
    } else {
      history && history.push({
        pathname: '/fireboard',
        state: { managerMode: true }
      });
    }
  };

  showErrorIfPreauthTipIsMore = () => {
    const popup = getPopupConfig('error');
    popup.heading = constants.errorPopupMessage;
    popup.message = 'Pre auth tip percent should not be more than allowed value';
    popup.buttons = [
      {
        text: constants.ok,
        onClick: () => this.closePopup(),
      }
    ];
    this.setState({ popup });
  };

  get viewProps() {
    const { popup, phoneNumber, item } = this.state;
    const { history, reduxProps } = this.props;
    const { currencyInfo } = reduxProps || {};
    const { location } = history || {};
    const { supportsGratuityForPreAuth, defaultPreAuthTipPercentage } = location?.state || {};

    return {
      popup,
      tipSubmit: this.tipSubmit,
      item,
      defaultPreAuthTipPercentage: defaultPreAuthTipPercentage,
      supportsGratuityForPreAuth: supportsGratuityForPreAuth,
      onClose: this.onClose,
      phoneNumber,
      currency: currencyInfo?.currency,
      showErrorIfPreauthTipIsMore: this.showErrorIfPreauthTipIsMore
    }
  };

  render() {
    const viewProps = this.viewProps;
    return (
      <View {...viewProps} />
    );
  };
}

const mapStateToProps = (reduxProps) => ({
  reduxProps,
});

export default connect(mapStateToProps, null)(FireboardPreAuth);
